<div class="edit-route__edit-info">
  <ci-icon-button
    class="banner__close-button"
    name="close" 
    type="standard"
    (click)="handleCloseClick()"
  ></ci-icon-button>
  
  <header class="edit-info__title">
    <h1 class="title__text ci-heading-h3-bold">
      {{ 'Cómo modificar tu itinerario' | translate }}
    </h1>
    <p class="ci-paragraph-p1-semibold">
      {{ 'Desde esta sección podrás modificar tu itinerario' | translate }}
    </p>
  </header>
  
  <main class="edit-info__content">
    <div class="content__item">
      <ci-icon
        class="edit-info__icon"
        name="gestion-contenidos-editor-visual"
        type="svg"
        scale="1.5x"
      ></ci-icon>
      <p class="ci-paragraph-p1-regular">
        {{ 'Para mover un recurso, simplemente selecciona y arrastra su tarjeta' | translate }}
      </p>
    </div>
    
    <div class="content__item">
      <ci-icon
        class="edit-info__icon"
        name="edit"
        type="svg"
        scale="1.5x"
      ></ci-icon>
      <p class="ci-paragraph-p1-regular">
        {{ 'Si deseas modificar el día u horario del recurso de manera manual, desliza el recurso para ver las opciones o pulsa en el icono de opciones' | translate }}
      </p>
    </div>
  </main>
  
  <footer class="edit-info__footer">
    <ci-button
      class="edit-info__button"
      class-name="ci-btn-primary-s-filled"
      [arial-label]="'Entendido' | translate"
      (click)="handleGotItClick()"
    >
      {{ 'Entendido' | translate }}
    </ci-button>
  </footer>
</div>
